<app-basic-page [pageTitle]="'Leads - First Message'" [pageDescription]="'Auto generate leads from LinkedIn'">
  <div class="vertical">
    <nz-tabset>
      <nz-tab [nzTitle]="pendingApprovalsTitle">
        <ng-template #pendingApprovalsTitle>
          <div class="horizontal no-gap">
            <span nz-icon class="material-symbols-rounded" [ngStyle]="{ marginRight: '2px' }">pause</span>
            <div>Pending Approvals ({{ pendingApprovalsLeadsList().length }})</div>
          </div>
        </ng-template>

        <div class="tab-content vertical">
          <nz-table
            class="full-width"
            #pendingApprovalsTable
            [nzData]="pendingApprovalsLeadsList()"
            [nzPaginationType]="'small'"
            [nzPageSize]="30"
          >
            <thead>
              <tr>
                <th [nzWidth]="'300px'">User</th>
                <th [nzWidth]="'150px'">LinkedIn</th>
                <th>Product</th>
                <th>First Message</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (data of pendingApprovalsTable.data; track data.id; let i = $index) {
                <tr>
                  <td>
                    <app-profile-card-small
                      [resume]="getResume(data.unsafeSubData.resumeId)()"
                    ></app-profile-card-small>
                  </td>
                  <td>
                    <a
                      [href]="getResume(data.unsafeSubData.resumeId)()?.subData?.url"
                      nz-button
                      nzType="link"
                      nzSize="small"
                      target="_blank"
                    >
                      <span nz-icon style="font-size: 16px" class="material-symbols-rounded">open_in_new</span>
                      LinkedIn
                    </a>
                  </td>
                  <td>
                    {{ getProduct(data.unsafeSubData.productId)()?.title }}
                  </td>
                  <td>
                    {{ data.unsafeSubData.secondMessage }}

                    <div class="horizontal buttons">
                      <nz-tag [ngStyle]="{ height: '21px' }">
                        Total Chars: {{ data.unsafeSubData.secondMessage?.length }}
                      </nz-tag>

                      <app-popover-edit-text
                        [buttonType]="'default'"
                        [content]="data.unsafeSubData.secondMessage"
                        (saveChange)="onSaveSecondMessageClick(data, $event)"
                      ></app-popover-edit-text>
                      <button nz-button nzType="default" nzSize="small" (click)="onRegenerateMessageClick(data)">
                        <span nz-icon style="font-size: 16px" class="material-symbols-rounded">refresh</span>
                        Regenerate
                      </button>
                    </div>
                  </td>
                  <td>
                    {{ getLastWordFromCamelCase(data.status) }}
                  </td>
                  <td>
                    <div class="vertical">
                      <button nz-button nzType="default" nzSize="small" (click)="onApproveLeadsClick(data)">
                        <span nz-icon style="font-size: 16px" class="material-symbols-rounded">check</span>
                        Approve
                      </button>
                      <button nz-button nzType="default" nzSize="small" (click)="onDeleteLeadsClick(data)">
                        <span nz-icon style="font-size: 16px" class="material-symbols-rounded">delete</span>
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </nz-table>
        </div>
      </nz-tab>
      <nz-tab [nzTitle]="processingQueueTitle">
        <ng-template #processingQueueTitle>
          <div class="horizontal no-gap">
            <span nz-icon class="material-symbols-rounded" [ngStyle]="{ marginRight: '2px' }">play_arrow</span>
            <div>Processing Queue ({{ processingQueueLeadsList().length }})</div>
          </div>
        </ng-template>
        <div class="tab-content">
          <nz-table
            class="full-width"
            #processingQueueLeadsTable
            [nzData]="processingQueueLeadsList()"
            [nzPaginationType]="'small'"
            [nzPageSize]="30"
          >
            <thead>
              <tr>
                <th>Id</th>
                <th [nzWidth]="'300px'">User</th>
                <th [nzWidth]="'150px'">LinkedIn</th>
                <th>Product</th>
                <th>Connect Message</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (data of processingQueueLeadsTable.data; track data.id; let i = $index) {
                <tr>
                  <td>
                    <app-copy-button [text]="data.id"></app-copy-button>
                  </td>
                  <td>
                    <app-profile-card-small
                      [resume]="getResume(data.unsafeSubData.resumeId)()"
                    ></app-profile-card-small>
                  </td>
                  <td>
                    <a
                      [href]="getResume(data.unsafeSubData.resumeId)()?.subData?.url"
                      nz-button
                      nzType="link"
                      nzSize="small"
                      target="_blank"
                    >
                      <span nz-icon style="font-size: 16px" class="material-symbols-rounded">open_in_new</span>
                      LinkedIn
                    </a>
                  </td>
                  <td>
                    {{ getProduct(data.unsafeSubData.productId)()?.title }}
                  </td>
                  <td>
                    {{ data.unsafeSubData.secondMessage }}
                    <div class="vertical buttons">
                      <app-popover-edit-text
                        [content]="data.unsafeSubData.secondMessage"
                        (saveChange)="onSaveSecondMessageClick(data, $event)"
                      ></app-popover-edit-text>

                      <div class="horizontal buttons">
                        <nz-tag [ngStyle]="{ height: '21px' }">
                          Total Chars: {{ data.unsafeSubData.secondMessage?.length }}
                        </nz-tag>

                        <app-popover-edit-text
                          [buttonType]="'default'"
                          [content]="data.unsafeSubData.secondMessage"
                          (saveChange)="onSaveSecondMessageClick(data, $event)"
                        ></app-popover-edit-text>

                        <button nz-button nzType="default" nzSize="small" (click)="onRegenerateMessageClick(data)">
                          <span nz-icon style="font-size: 16px" class="material-symbols-rounded">refresh</span>
                          Regenerate
                        </button>
                      </div>
                    </div>
                  </td>
                  <td>
                    {{ getLastWordFromCamelCase(data.status) }}
                  </td>
                  <td>
                    <div class="vertical">
                      <button nz-button nzType="default" nzSize="small" (click)="onSendMessageClick(data)">
                        <span nz-icon style="font-size: 16px" class="material-symbols-rounded">mail</span>
                        Send Message Now
                      </button>
                      <button nz-button nzType="default" nzSize="small" (click)="onMarkAsDoneClick(data)">
                        <span nz-icon style="font-size: 16px" class="material-symbols-rounded">check</span>
                        Mark as Done
                      </button>
                      <button nz-button nzType="default" nzSize="small" (click)="onDeleteLeadsClick(data)">
                        <span nz-icon style="font-size: 16px" class="material-symbols-rounded">delete</span>
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </nz-table>
        </div>
      </nz-tab>
      <nz-tab [nzTitle]="failedSecondMessageTitle">
        <ng-template #failedSecondMessageTitle>
          <div class="horizontal no-gap">
            <span nz-icon class="material-symbols-rounded" style="font-size: 20px" [ngStyle]="{ marginRight: '2px' }"
              >error</span
            >
            <div>Failed First Message ({{ failedSecondMessageList().length }})</div>
          </div>
        </ng-template>

        <div class="tab-content">
          <nz-table
            class="full-width"
            #failedSecondTable
            [nzData]="failedSecondMessageList()"
            [nzPaginationType]="'small'"
            [nzPageSize]="30"
          >
            <thead>
              <tr>
                <th>Id</th>
                <th [nzWidth]="'300px'">User</th>
                <th [nzWidth]="'150px'">LinkedIn</th>
                <th>Product</th>
                <th>Connect Message</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (data of failedSecondTable.data; track data.id; let i = $index) {
                <tr>
                  <td>
                    <app-copy-button [text]="data.id"></app-copy-button>
                  </td>
                  <td>
                    <app-profile-card-small
                      [resume]="getResume(data.unsafeSubData.resumeId)()"
                    ></app-profile-card-small>
                  </td>
                  <td>
                    <a
                      [href]="getResume(data.unsafeSubData.resumeId)()?.subData?.url"
                      nz-button
                      nzType="link"
                      nzSize="small"
                      target="_blank"
                    >
                      <span nz-icon style="font-size: 16px" class="material-symbols-rounded">open_in_new</span>
                      LinkedIn
                    </a>
                  </td>
                  <td>
                    {{ getProduct(data.unsafeSubData.productId)()?.title }}
                  </td>
                  <td>
                    {{ data.unsafeSubData.secondMessage }}
                    <div class="vertical buttons">
                      <div class="horizontal buttons">
                        <nz-tag [ngStyle]="{ height: '21px' }">
                          Total Chars: {{ data.unsafeSubData.secondMessage?.length }}
                        </nz-tag>

                        <app-popover-edit-text
                          [buttonType]="'default'"
                          [content]="data.unsafeSubData.secondMessage"
                          (saveChange)="onSaveSecondMessageClick(data, $event)"
                        ></app-popover-edit-text>

                        <button nz-button nzType="default" nzSize="small" (click)="onRegenerateMessageClick(data)">
                          <span nz-icon style="font-size: 16px" class="material-symbols-rounded">refresh</span>
                          Regenerate
                        </button>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div>{{ getLastWordFromCamelCase(data.status) }}</div>
                    <div>{{ data.statusMessage }}</div>
                  </td>
                  <td>
                    <div class="vertical">
                      <button nz-button nzType="default" nzSize="small" (click)="onApproveLeadsClick(data)">
                        <span nz-icon style="font-size: 16px" class="material-symbols-rounded">refresh</span>
                        Retry
                      </button>
                      <button nz-button nzType="default" nzSize="small" (click)="onMarkAsDoneClick(data)">
                        <span nz-icon style="font-size: 16px" class="material-symbols-rounded">check</span>
                        Mark as Done
                      </button>
                      <button nz-button nzType="default" nzSize="small" (click)="onDeleteLeadsClick(data)">
                        <span nz-icon style="font-size: 16px" class="material-symbols-rounded">delete</span>
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </nz-table>
        </div>
      </nz-tab>

      <nz-tab [nzTitle]="waitingForResponseTitle">
        <ng-template #waitingForResponseTitle>
          <div class="horizontal no-gap">
            <span nz-icon class="material-symbols-rounded" style="font-size: 20px" [ngStyle]="{ marginRight: '2px' }"
              >hourglass_empty</span
            >
            <div>Awaiting a Response ({{ sentSecondMessageList().length }})</div>
          </div>
        </ng-template>

        <div class="tab-content">
          <nz-table
            class="full-width"
            #sentSecondTable
            [nzData]="sentSecondMessageList()"
            [nzPaginationType]="'small'"
            [nzPageSize]="30"
          >
            <thead>
              <tr>
                <th>Id</th>
                <th [nzWidth]="'300px'">User</th>
                <th [nzWidth]="'150px'">LinkedIn</th>
                <th>Product</th>
                <th>Connect Message</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (data of sentSecondTable.data; track data.id; let i = $index) {
                <tr>
                  <td>
                    <app-copy-button [text]="data.id"></app-copy-button>
                  </td>
                  <td>
                    <app-profile-card-small
                      [resume]="getResume(data.unsafeSubData.resumeId)()"
                    ></app-profile-card-small>
                  </td>
                  <td>
                    <a
                      [href]="getResume(data.unsafeSubData.resumeId)()?.subData?.url"
                      nz-button
                      nzType="link"
                      nzSize="small"
                      target="_blank"
                    >
                      <span nz-icon style="font-size: 16px" class="material-symbols-rounded">open_in_new</span>
                      LinkedIn
                    </a>
                  </td>
                  <td>
                    {{ getProduct(data.unsafeSubData.productId)()?.title }}
                  </td>
                  <td>
                    {{ data.unsafeSubData.secondMessage }}
                  </td>
                  <td>
                    {{ getLastWordFromCamelCase(data.status) }}
                  </td>
                  <td>
                    <div class="vertical">
                      <button nz-button nzType="default" nzSize="small">
                        <span nz-icon style="font-size: 18px" class="material-symbols-rounded">phone_in_talk</span>
                        Meeting Practice
                      </button>
                      <button nz-button nzType="default" nzSize="small" (click)="onDeleteLeadsClick(data)">
                        <span nz-icon style="font-size: 16px" class="material-symbols-rounded">delete</span>
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </nz-table>
        </div>
      </nz-tab>

      <nz-tab [nzTitle]="messageReceivedTitle">
        <ng-template #messageReceivedTitle>
          <div class="horizontal no-gap">
            <div>🎉 Respond Received! ({{ linkedInRespondedList().length }})</div>
          </div>
        </ng-template>

        <div class="tab-content vertical">
          <nz-table
            class="full-width"
            #receivedMessageTable
            [nzData]="linkedInRespondedList()"
            [nzPaginationType]="'small'"
            [nzPageSize]="30"
          >
            <thead>
              <tr>
                <th>Id</th>
                <th [nzWidth]="'300px'">User</th>
                <th [nzWidth]="'150px'">LinkedIn</th>
                <th>Product</th>
                <th>Connect Message</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (data of receivedMessageTable.data; track data.id; let i = $index) {
                <tr>
                  <td>
                    <app-copy-button [text]="data.id"></app-copy-button>
                  </td>
                  <td>
                    <app-profile-card-small
                      [resume]="getResume(data.unsafeSubData.resumeId)()"
                    ></app-profile-card-small>
                  </td>
                  <td>
                    <a
                      [href]="getResume(data.unsafeSubData.resumeId)()?.subData?.url"
                      nz-button
                      nzType="link"
                      nzSize="small"
                      target="_blank"
                    >
                      <span nz-icon style="font-size: 16px" class="material-symbols-rounded">open_in_new</span>
                      LinkedIn
                    </a>
                  </td>
                  <td>
                    {{ getProduct(data.unsafeSubData.productId)()?.title }}
                  </td>
                  <td>
                    {{ data.unsafeSubData.secondMessage }}
                  </td>
                  <td>
                    {{ getLastWordFromCamelCase(data.status) }}
                  </td>
                  <td>
                    <div class="vertical">
                      <button nz-button nzType="default" nzSize="small">
                        <span nz-icon style="font-size: 18px" class="material-symbols-rounded">phone_in_talk</span>
                        Meeting Practice
                      </button>
                      <button nz-button nzType="default" nzSize="small" (click)="onDeleteLeadsClick(data)">
                        <span nz-icon style="font-size: 16px" class="material-symbols-rounded">delete</span>
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </nz-table>
        </div>
      </nz-tab>
    </nz-tabset>
  </div>
</app-basic-page>
